import request from '@/router/axios'

export default class BaseApi {
    PRIMARY_KEY = 'id'
    BASE_PATH = ''
    
    static instance() {
        if (this._instance) {
            return this._instance;
        }
        return new BaseApi();
    }

    add(data = {}) {
        return request(this.BASE_PATH, { data }, 'post');
    }

    update(data = {}) {
        return request(this.BASE_PATH, { data }, 'put');
    }

    duplicateCheck(params = {}) {
        return request(`${this.BASE_PATH}/duplicateCheck`, { params })
    }

    get(id) {
        return request(`${this.BASE_PATH}/${id}`);
    }

    getEntityByUid(uid = '') {
        return request(`${this.BASE_PATH}/${uid}/detail`);
    }

    remove(id) {
        return request(`${this.BASE_PATH}/${id}`, {}, 'delete')
    }

    deleteBatch(data = []) {
        return request(`${this.BASE_PATH}/deleteBatch`, { data }, 'delete');
    }

    deleteBatchByUid(data = []) {
        return request(`${this.BASE_PATH}/deleteBatchByUid`, { data }, 'delete')
    }

    all() {
        return request(`${this.BASE_PATH}/all`)
    }

    getList(params = {}) {
        return request(`${this.BASE_PATH}/getList`, { params })
    }

    page(params = {}) {
        return request(`${this.BASE_PATH}/page`, { params })
    }

    query(page = 10, limit = 10, params = {}) {
        return request(`${this.BASE_PATH}/query`, {
            params: {
                ...params,
                page,
                limit
            }
        });
    }

    export(params = {}) {
        return request(`${this.BASE_PATH}/export`, { params })
    }

    importExcel(file = new File) {
        let data = new FormData(); // FormData 对象
        data.append("file", file); // 文件对象

        return request(`${this.BASE_PATH}/import`, { data }, 'post');
    }
}